export default {
  props: {
    control: Object
  },
  computed: {
    optionControlSelectList() {
      if (!["radio", "select", "option"].includes(this.control._type)) return []
      return (this.control.options || []).map(option => ({
        label: this._.isString(option) ? option : option.label,
        value: this._.isString(option) ? option : option.value
      }))
    }
  }
}
